import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class EndPointApi {
    private static url: string = null;

    /**
     * Get URL for HTTP API requests
     * Returns empty string in production (for relative paths)
     * Returns full URL with port in development
     */
    public static getURL() {
        if (!this.url) {
            if (environment.apiEndpoint) {
                this.url = environment.apiEndpoint;
            } else if (environment.apiPort) {
                // Development environment: use apiPort
                const protocol = location.protocol;
                const hostname = location.hostname;
                this.url = `${protocol}//${hostname}:${environment.apiPort}`;
                console.log('[EndPointApi] Development mode - getURL:', this.url);
            } else {
                // Production environment: use empty string for relative paths
                // HTTP requests will use relative URLs like /api/settings
                this.url = '';
                console.log('[EndPointApi] Production mode - getURL: (empty string for relative paths)');
            }
        }
        return this.url;
    }

    /**
     * Get full URL for Socket.IO connections
     * Always returns full URL with protocol and hostname
     */
    public static getSocketURL() {
        if (environment.apiEndpoint) {
            console.log('[EndPointApi] getSocketURL - using apiEndpoint:', environment.apiEndpoint);
            return environment.apiEndpoint;
        } else if (environment.apiPort) {
            // Development environment: use apiPort
            const protocol = location.protocol;
            const hostname = location.hostname;
            const url = `${protocol}//${hostname}:${environment.apiPort}`;
            console.log('[EndPointApi] Development mode - getSocketURL:', url);
            return url;
        } else {
            // Production environment: use current origin without port
            const protocol = location.protocol;
            const hostname = location.hostname;
            const url = `${protocol}//${hostname}`;
            console.log('[EndPointApi] Production mode - getSocketURL:', url);
            return url;
        }
    }

    public static getRemoteURL(destIp: string) {
        const protocoll = location.origin.split(':')[0];
        const path = destIp + ':' + environment.apiPort;
        return protocoll + '://' + path + '/api';

    }

    public static resolveUrl = (input?: string) => {
        if (!input) {
            return '';
        }
        try { return new URL(input, window.location.origin).toString(); }
        catch { return input.startsWith('/') ? input : '/' + input; }
    };
}
